import type { CSSProperties } from '@linaria/core';
import { cx } from '@linaria/core';
import { memo } from 'react';
import "./BouncingDots.linaria.module.css!=!./BouncingDots?./BouncingDots.linaria.module.css?css=H4sIAAAAAAAAA5WSz47aMBDG7zxFLkikqlFMAS3hUqlP0ZPl2ONkSGKnthMIFu9eJQvhz+5K7Zzm8/z02Z6ZJfc1U4LRYmsO7Xn5LMOhdR5VT4TRHrRPBWgPdn+ZjeDOMUq3fcLLINE1Fe9T1BVqIKqC040qnswnFXiFuSbooXYvvl3BdGky1YUOrEfBKzLCaY1SVnDDxInRQnW71oScN2nH7YIQaTzJeRPvL7OfJfTK8hpclJlWC9T5UHbkyDuIwiy6RjL/PuVvj4ImyfyBG8Jbrp0ytk7f04p7+L1I4v0TZRou0PdplCzXm3vpMmXrfzQWvBKL+8csOoijbxGh8Vc30tfrrs1aSUbtDyqOzYsMGRdlbk2rJRGmMjYVrbWg/a9B3Hq9OTDqXIayCJmxEiyxXGLr0k0yvzGwYpTLdc5FKADzwj+MxOEZ4mm+/QQeUfriK65hNMP1gb4FrrHmHo1OP5kkXa5cBNwBQU1M6yPUCjX6aVH+MHqCs+mbZ3V3JRKG5b0/Y9TjDtUgkUeLxoIC64gF2QqQpDbja6J3HYdrAxpqjiyv+qOqP548/EIbDfvLf9pvrCptwZQtrdp9PAm3HUiW28H7L/9vbWDbAwAA"
const rootStyles = "atm_fc_1h6ojuz atm_9s_116y0ak atm_h_1h6ojuz atm_vh_nkobfv atm_cx_1hfv9uo";

// The wave: each dot rises and brightens once per cycle, and the delays
// stagger them so the crest travels left to right. Colour is currentColor,
// so a dot picks up the text colour of whatever it stands in for.
const dotStyles = "atm_2d_1r31cwp atm_5j_1ssbidh atm_e2_1ad4gac atm_vy_1ad4gac atm_p_1bi4j18 atm_q_1xezoyp atm_e2p1ow_glywfm atm_5rfkrh_frkrf9";
const DOT_COUNT = 3;
const WAVE_STAGGER_SECONDS = 0.16;
type BouncingDotsProps = {
  /** dot diameter in px */
  size?: number;
  /** space between dots in px; defaults to the dot size */
  gap?: number;
  /** how far a dot rises in px; defaults to the dot size */
  rise?: number;
  /**
   * what the dots stand in for, read by assistive tech (e.g. "Loading
   * model count"); without one the dots are purely decorative and hidden
   */
  label?: string;
  className?: string;
};

/**
 * Three dots bouncing in a wave: a compact loading indicator for a value
 * that is on its way, sized to sit inline with the text it replaces.
 */
const BouncingDots = memo((props: BouncingDotsProps) => {
  const {
    size = 4,
    gap = size,
    rise = size,
    label,
    className
  } = props;
  return <span data-testid="BouncingDots" role={label ? 'status' : undefined} aria-label={label} aria-hidden={label ? undefined : true} style={{
    '--dot-size': size + 'px',
    '--dot-gap': gap + 'px',
    '--dot-rise': rise + 'px'
  } as CSSProperties} className={cx(rootStyles, className)}>
            {Array.from({
      length: DOT_COUNT
    }, (_, index) => <span key={index} style={{
      '--dot-delay': index * WAVE_STAGGER_SECONDS + 's'
    } as CSSProperties} className={dotStyles} />)}
        </span>;
});
export default BouncingDots;